// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-container[data-v-838841e0] .nav-item.active .nav-link {\n  color: #000;\n}\n.tab-container .nav-link[data-v-838841e0] {\n  padding: 0.5rem 1rem 0.1rem 0 !important;\n  color: #9DA8B7;\n}\n.tab-container .nav-item[data-v-838841e0] {\n  padding: 0.5rem 1rem 0 0 !important;\n}\n.cs-search-box[data-v-838841e0] {\n  margin-bottom: 0;\n}\n.cs-search-box .card[data-v-838841e0] {\n  margin: 16px 16px 0 16px;\n}\n", ""]);
// Exports
module.exports = exports;
